<template>
  <sl-side-panel v-model="modalVisible" :mask-closable="false" :title="itemTitle">
    <Form class="sm" ref="form" :model="form" :rules="rules" :label-width="100">
      <FormItem label="品牌编码" prop="brandCode">
        <Input v-model="form.brandCode"></Input>
      </FormItem>
      <FormItem label="品牌全称" prop="brandFullName">
        <Input v-model="form.brandFullName"></Input>
      </FormItem>
      <FormItem label="品牌简称" prop="brandShortName">
        <Input v-model="form.brandShortName"></Input>
      </FormItem>
      <FormItem label="品牌类型" prop="type">
        <Select v-model="form.type">
          <Option v-for="(item,index) in typeData" :value="item.value" :key="'type'+index">{{ item.label }}</Option>
        </Select>
      </FormItem>
      <FormItem label="品牌图片" prop="brandLogo">
        <sl-upload v-model="form.brandLogo" type="4">建议尺寸：320*480，支持格式：jpg, png, bmp , gif</sl-upload>
      </FormItem>
      <FormItem label="备注" prop="remark">
        <Input type="textarea" :autosize="{minRows: 2,maxRows: 5}" v-model="form.remark"></Input>
      </FormItem>
    </Form>
    <div slot="footer" style="text-align: right; padding-top:12px;">
      <Button :loading="loading" @click="handleSubmit('form')" type="primary">确定</Button>
    </div>
  </sl-side-panel>
</template>
<script>
export default {
  props: {
    typeData: Array
  },
  data() {
    return {
      rules: {
        brandCode: [
          { required: true, message: '请输入品牌编码', trigger: 'blur,change' },
        ],
        brandFullName: [
          { required: true, message: '请输入品牌全称', trigger: 'blur,change' },
        ],
        type: [
          { required: true, type: 'number', message: '请选择品牌类型', trigger: 'blur,change' },
        ]
      },
      form: {
        id: null,
        brandFullName: null,
        brandShortName: null,
        type: null,
        brandLogo: null,
        remark: null
      },
      loading: false,
      modalVisible: false
    }
  },

  computed: {
    itemTitle() {
      return this.form.id ? '修改' : '新增'
    }
  },
  watch: {},

  mounted() {
  },

  methods: {
    initData(row) {
      this.form = JSON.parse(JSON.stringify(row))
    },

    save() {
      let params = { ...this.form }

      this.loading = true
      let promise = this.form.id ? this.$request.brandUpdate : this.$request.brandCreate
      promise(params).then(resp => {

        if (resp.code) {
          this.$Message.error({ content: resp.msg })
        } else {
          this.$Message.success('保存成功')
          this.$emit('on-update')
          this.hide()
        }
        this.loading = false
      })

    },
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.save()
        } else {
          this.$Message.error('参数错误');
        }
      })
    },
    show() {
      this.modalVisible = true
      this.$refs.form.resetFields()
      this.form = {}
    },
    hide() {
      this.modalVisible = false
    }
  }
}

</script>
